module.exports = __webpack_public_path__ + "img/affiliated.e739d503.jpg";